import { Inject, Injectable } from '@angular/core';
import { MAT_SNACK_BAR_DEFAULT_OPTIONS, MatSnackBar, MatSnackBarConfig } from '@angular/material/snack-bar';
import { SnackbarComponent } from './snackbar.component';
import { tap, throwError } from 'rxjs';
import { SnackbarType } from '@shared/models/snackbar.model';

@Injectable({ providedIn: 'root' })
export class SnackbarService {
  constructor(
    @Inject(MAT_SNACK_BAR_DEFAULT_OPTIONS) public defaults: MatSnackBarConfig,
    private snackbar: MatSnackBar
  ) {
  }

  private open(type: SnackbarType, message: string, options?: MatSnackBarConfig) {
    const config = { ...this.defaults, ...options };
    this.snackbar.openFromComponent(SnackbarComponent, {
      ...config,
      data: { type, message },
    });
  }

  success(message: string, options: { duration: number } = { duration: 1000 }) {
    this.open(SnackbarType.SUCCESS, message, options);
  }

  info(message: string) {
    this.open(SnackbarType.INFO, message);
  }

  error(message: string, options: { duration: number } = { duration: 5000 }) {
    this.open(SnackbarType.ERROR, message, options);
  }

  operator(successMessage: string | null = null, options: { duration: number } = { duration: 1000 }) {
    return (source: any) => {
      return source.pipe(
        tap({
          next: () => {
            if (successMessage) this.success(successMessage, options);
          },
          error: (error) => throwError(() => error)
        })
      );
    };
  }
}
